import gql from 'graphql-tag'

export const DARKGRAY_EMPLOYER = gql`
 mutation(
  $employerId:ID
  $reasonDarkGray: String
  $files:[String]
){  addDarkGraylist(info:{
    employerId: $employerId
    reasonDarkGray:$reasonDarkGray
	files:$files
  })
  }
    `
export const UPDATE_DARKGRAY_EMPLOYER = gql`
mutation(
$_id:ID
 $employerId:ID
 $reasonDarkGray: String
 $files:[String]
){  updateDarkGraylist(info:{
	_id:$_id
   employerId: $employerId
   reasonDarkGray:$reasonDarkGray
   files:$files
 })
 }
 `
export const CANCELDARKGRAY_EMPLOYER = gql`
mutation(
$_id:ID
 $employerId:ID
 $reasonCancelDarkGray: String
 $files:[String]
){  cancelDarkGraylist(info:{
	_id:$_id
   employerId: $employerId
   reasonCancelDarkGray:$reasonCancelDarkGray
   files:$files
 })
 }
 `
export const GET_DARKGRAYLIST = gql`
 query(
	$page:Int
	$perPage:Int
	$search:Boolean
){
	get_DarkGraylist(page:$page perPage:$perPage search:$search){
		info{
			_id
			logo
			companyName
			reasonDarkGray
			reasonCancelDarkGray
			createdAt
			files
			auth
		}
	}
}
 `

export const GETDARKGRAYID = gql`
 
 query(
	$_id:ID
){
	getDarkGrayById(_id:$_id){
			_id
			logo
			employerId
			companyName
			reasonDarkGray
			reasonCancelDarkGray
			createdAt
			files
			auth
	}
}
 `